import { Injectable } from '@angular/core';
import { Constants } from '../helper/constants';
import { HttpService } from '../helper/httpService';
import { DocumentsModel } from '../viewmodels/documents.model';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentsService {
  private documentsServiceUrl = Constants.serverUrl + 'api/documents/';

  constructor(public http: HttpService) {
  }

  /** getDocuments */
  getDocuments(pcnNumber: string): Observable<any> {
    return this.http.Get(this.documentsServiceUrl +
      'getDocuments' +
      '/' +
      pcnNumber);
  }

   /** getDocuments */
   getSelectedDocuments(pcnNumber: string): Observable<any> {
    return this.http.Get(this.documentsServiceUrl +
      'getSelectedDocuments' +
      '/' +
      pcnNumber);
  }

  addSelectedDocument(documentId: number, pcnNumber: string): Observable<any> {
    return this.http.Get(this.documentsServiceUrl +
        'addSelectedDocument' +
        '/' +
        documentId +
        '/' +
        pcnNumber
      );
  }

  removeSelectedDocument(documentId: number, pcnNumber: string): Observable<any> {
    return this.http.Get(this.documentsServiceUrl +
        'removeSelectedDocument' +
        '/' +
        documentId +
        '/' +
        pcnNumber
      );
  }
}
